import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { PopoverComponentComponent } from "./components/popover-component/popover-component.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { InvitationsComponent } from "./components/invitations/invitations.component";
import { MaterialModule } from "../material-file/material.module";
import { AnyReportComponent } from "./components/any-report/any-report.component";
// import { CallNumber } from "@ionic-native/call-number/ngx";
import { SidebarService } from "../services/sidebar.service";
import { FileUploadModule } from "ng2-file-upload";
// import { ImageSliderComponent } from "./components/image-slider/image-slider.component";
// import { NgxIonicImageViewerModule } from "ngx-ionic-image-viewer";
import { ProfileImageComponent } from "./components/profile-image/profile-image.component";
import { SharedServices } from "../services/shared.service";
import { MatExpansionModule } from "@angular/material/expansion";

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { RequestInterceptor } from "../services/interceptor/RequestInterceptor";
import { CustomDatePipe } from "../core-files/pipes/custom.datepipe";
import { LoginAlert } from "../core-files/login-alert-dialog";
import { SubscriptionExpiredComponent } from "./components/subscription-expired/subscription-expired.component";
import { HeaderToolBarComponent } from "./components/header-tool-bar/header-tool-bar.component";
import { CreateActivityComponent } from "./components/create-activity/create-activity.component";
import { RescheduleActivityComponent } from "./components/reschedule-activity/reschedule-activity.component";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { CountdownComponent } from "ngx-countdown";
import { SubHeaderToolbarComponent } from "./components/sub-header-toolbar/sub-header-toolbar.component";
import { UserLoginDialogComponent } from "./components/user-login-dialog/user-login-dialog.component";
import { ImageViewerComponent } from "./components/image-viewer/image-viewer.component";
import { SkeletonBuilderProjectComponent } from "./components/skeleton-components/skeleton-builder-project/skeleton-builder-project.component";
import { SkeletonPropertyComponent } from "./components/skeleton-components/skeleton-property/skeleton-property.component";
import { SkeletonPropertyDetailComponent } from "./components/skeleton-components/skeleton-property-detail/skeleton-property-detail.component";
import { DeleteConfirmDialogComponent } from "./components/delete-confirm-dialog/delete-confirm-dialog.component";
import { DialogEditTeamComponent } from "./components/dialog-edit-team/dialog-edit-team.component";
import { SkeletonEmpTeamComponent } from "./components/skeleton-components/skeleton-emp-team/skeleton-emp-team.component";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { DateTimePickerComponent } from "./components/date-time-picker/date-time-picker.component";
import { NoDataFoundComponent } from "./components/no-data-found/no-data-found.component";
import { ErrorComponent } from "./components/error/error.component";
import { SearchUserPipe } from "./pipes/search-user.pipe";
import { ResponseSaveDialog } from "../modules/agent/pages/tele-calling-user-list/tele-calling-user-list.page";
import { DialogInfoDetailsComponent } from "./components/dialog-info-details/dialog-info-details.component";
import { ImportCallingContactComponent } from "./components/import-calling-contact/import-calling-contact.component";
import { WhatsAppMessageDialogComponent } from "./components/whatsapp-message-dialog/whatsapp-message-dialog.component";
import { SocietyFilterDivPipe } from "./pipes/society-filter-div.pipe";
import { AreaFilterPipe } from "./pipes/area-filter.pipe";
import { UploadProjectBrochureComponent } from "../modules/agent/pages/property-list/components/my-builder-project/upload-project-brochure/upload-project-brochure.component";
import { IonicModule } from "@ionic/angular";
import { UploadPropertyImagesComponent } from "./components/upload-property-images/upload-property-images.component";
import { SocietyFilterPipe } from "./pipes/society-filter.pipe";
import { DialogLinkLeadComponent } from "./components/dialog-link-lead/dialog-link-lead.component";
import { DialogLinkPropertyComponent } from "./components/dialog-link-property/dialog-link-property.component";
import { AgentCityComponent } from "./components/agent-city/agent-city.component";
import { SharePropertyConfirmDialogComponent } from "./components/share-property-confirm-dialog/share-property-confirm-dialog.component";
import { ImagePreviewComponent } from "./components/image-preview/image-preview.component";
@NgModule({
  declarations: [
    LoaderComponent,
    PopoverComponentComponent,
    InvitationsComponent,
    AnyReportComponent,
    // ImageSliderComponent,
    ProfileImageComponent,
    CustomDatePipe,
    SubscriptionExpiredComponent,
    HeaderToolBarComponent,
    CreateActivityComponent,
    RescheduleActivityComponent,
    SubHeaderToolbarComponent,
    UserLoginDialogComponent,
    ImageViewerComponent,
    SkeletonBuilderProjectComponent,
    SkeletonPropertyComponent,
    SkeletonPropertyDetailComponent,
    SkeletonEmpTeamComponent,
    DeleteConfirmDialogComponent,
    DialogEditTeamComponent,
    DateTimePickerComponent,
    NoDataFoundComponent,
    ErrorComponent,
    SearchUserPipe,
    ResponseSaveDialog,
    DialogInfoDetailsComponent,
    ImportCallingContactComponent,
    WhatsAppMessageDialogComponent,
    AreaFilterPipe,
    SocietyFilterDivPipe,
    SocietyFilterPipe,
    UploadProjectBrochureComponent,
    UploadPropertyImagesComponent,
    DialogLinkLeadComponent,
    DialogLinkPropertyComponent,
    AgentCityComponent,
    SharePropertyConfirmDialogComponent,
    ImagePreviewComponent
  ],
  exports: [
    MatExpansionModule,
    LoaderComponent,
    PopoverComponentComponent,
    InvitationsComponent,
    AnyReportComponent,
    ProfileImageComponent,
    // ImageSliderComponent,
    SubscriptionExpiredComponent,
    HeaderToolBarComponent,
    RescheduleActivityComponent,
    CountdownComponent,
    SubHeaderToolbarComponent,
    UserLoginDialogComponent,
    SkeletonBuilderProjectComponent,
    SkeletonPropertyComponent,
    SkeletonPropertyDetailComponent,
    SkeletonEmpTeamComponent,
    DeleteConfirmDialogComponent,
    DialogEditTeamComponent,
    DateTimePickerComponent,
    NoDataFoundComponent,
    ErrorComponent,
    SearchUserPipe,
    DialogInfoDetailsComponent,
    ImportCallingContactComponent,
    WhatsAppMessageDialogComponent,
    AreaFilterPipe,
    SocietyFilterDivPipe,
    // UploadPropertyImagesComponent
    DialogLinkLeadComponent,
    DialogLinkPropertyComponent,
    SharePropertyConfirmDialogComponent,
    ImagePreviewComponent

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FileUploadModule,
    MatExpansionModule,
    MaterialModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    // NgxIonicImageViewerModule,
    CountdownComponent,
    IonicModule
  ],
  providers: [
    SidebarService,
    SharedServices,
    CustomDatePipe,
    LoginAlert,
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    DatePipe,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModuleModule { }
